import { render, staticRenderFns } from "./SelectBWADialog.vue?vue&type=template&id=053aef18&scoped=true"
import script from "./SelectBWADialog.vue?vue&type=script&lang=js"
export * from "./SelectBWADialog.vue?vue&type=script&lang=js"
import style0 from "./SelectBWADialog.vue?vue&type=style&index=0&id=053aef18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053aef18",
  null
  
)

export default component.exports